import { all, call, takeLatest, put, select, take, race, takeEvery, delay } from 'redux-saga/effects'
import NProgress from 'nprogress'
import {
  ROUTE_CHANGE_STARTED,
  ROUTE_CHANGE_COMPLETED,
  ROUTE_CHANGE_FAILED,
  CLICK_CREATE_JOB,
  ADD_TOASTER,
  startWaiting,
  stopWaiting,
  displayProductModal,
  clickCreateJob,
  addToaster,
  removeToaster,
} from '../../actions/ui/ui'
import { createDraft } from '../../actions/draft/draft'
import { SET } from '../../actions/entitlement/entitlement'
import {
  getEntitlementsAreLoaded,
  userOwnsPbpCredits
} from '../../selectors/entitlement/entitlement'
import { selectUser } from '../../selectors/user/user'
import type { DashboardUser } from '../../../schema/user'
import { SET_INFO } from '../../actions/user/user'

export function* routeChangeStartedSaga(): Generator<any, void, any> {
  yield call(NProgress.start)
}

export function* routeChangeCompletedSaga():
  Generator<any, void, any> {
  yield put(stopWaiting())
  yield call(NProgress.done)
}

export function* routeChangeFailedSaga(): Generator<any, void, any> {
  yield call(NProgress.done)
}

export function* proceedCreateJob() {
  const isEligibleForPbpFlow = yield select(userOwnsPbpCredits)
  if (isEligibleForPbpFlow) {
    yield put(displayProductModal())
    yield put(stopWaiting())
  } else {
    yield put(createDraft({ product: null }))
  }
}

export function* clickCreateJobSaga({ payload: elementId }: ReturnType<typeof clickCreateJob>) {
  const entitlementsAreLoaded: boolean = yield select(getEntitlementsAreLoaded)
  const user: DashboardUser = yield select(selectUser)
  const userIsInitialized = user.isInitialized

  if (!entitlementsAreLoaded || !userIsInitialized) {
    // Need to wait for necessary data to be fetched
    yield put(startWaiting(elementId))
  }

  if (!entitlementsAreLoaded && !userIsInitialized) {
    // Wait for both entitlements and user data
    yield all([
      take(SET),
      take(SET_INFO),
    ])
  } else if (!entitlementsAreLoaded) {
    // Wait only for entitlements data
    yield (take(SET))
  } else if (!userIsInitialized) {
    // Wait only for user data
    yield (take(SET_INFO))
  }

  yield proceedCreateJob()
}

export function* addToasterSaga({ payload }: ReturnType<typeof addToaster>) {
  yield delay(5000)
  yield put(removeToaster(payload.id))
}

export default function* saga(): Generator<any, void, void> {
  yield all([
    takeLatest(ROUTE_CHANGE_STARTED, routeChangeStartedSaga),
    takeLatest(ROUTE_CHANGE_COMPLETED, routeChangeCompletedSaga),
    takeLatest(ROUTE_CHANGE_FAILED, routeChangeFailedSaga),
    takeLatest(CLICK_CREATE_JOB, clickCreateJobSaga),
    takeEvery(ADD_TOASTER, addToasterSaga)
  ])
}
